import * as uploadFileEndPoints from "../constants/endpoints/uploadFile";
import axios from "../axios/axios";

export const uploadAudioFile = (base64) => {
  return axios({
    url: uploadFileEndPoints.uploadAudioFile,
    method: "POST",
    data: {
      file: base64,
    },
  });
};

export const uploadImageFile = (base64) => {
  return axios({
    url: uploadFileEndPoints.uploadImageFile,
    method: "POST",
    data: {
      image: base64,
    },
  });
};
